import { Injectable } from '@angular/core';
import { UseService } from '@df/util/service/use.service';
import { BehaviorSubject } from 'rxjs';

const useId = 'blockStickyService';
@Injectable({
    providedIn: 'root'
})
export class BlockStickyService {
    constructor(private useService: UseService) {}

    get state$(): BehaviorSubject<boolean> {
        return this.useService.getState(useId).obs;
    }

    disallow(blockingObject: any): void {
        this.useService.lock(useId, blockingObject);
    }

    allow(blockingObject: any): void {
        this.useService.unlock(useId, blockingObject);
    }
}
